import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArchivedPeopleOutlineIcon = (props: IconProps) => (
  <Icon width="19px" height="18px" viewBox="0 0 19 18" {...props}>
    <circle cx="9.36523" cy="9" r="9" fill="#D6D6D6" />
    <path d="M11.7653 8.39999c.996 0 1.794-.804 1.794-1.8s-.798-1.8-1.794-1.8-1.80004.804-1.80004 1.8.80404 1.8 1.80004 1.8Zm-4.80004 0c.996 0 1.794-.804 1.794-1.8s-.798-1.8-1.794-1.8-1.8.804-1.8 1.8.804 1.8 1.8 1.8Zm0 1.2c-1.398 0-4.2.70201-4.2 2.10001v1.5h8.40004v-1.5c0-1.398-2.80204-2.10001-4.20004-2.10001Zm4.80004 0c-.174 0-.372.012-.582.03.696.50401 1.182 1.18201 1.182 2.07001v1.5h3.6v-1.5c0-1.398-2.802-2.10001-4.2-2.10001Z" />
  </Icon>
);

export default memo(ArchivedPeopleOutlineIcon);
